/* Quick add for MBC bundles (sitewide).
   The MBC Bundles app intercepts any plain /cart/add of a bundle product, blocks it
   (fake 402) and opens its own "complete your routine" popup instead, so quick-add
   buttons on routines never added anything. This handler adds the bundle the same
   way MBC's own popup does (/cart/add.js?mbcb-request with the component line
   properties), then refreshes and opens the cart drawer. Non-bundle products are
   left to the theme's normal quick add. */
(function () {
  if (window.__rcBundleAdd) return;
  window.__rcBundleAdd = true;

  var SECTIONS = [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  function findBundle(handle) {
    var data = window.MAKEBECOOL_BUNDLES;
    var list = (data && data.allBundles) || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle && list[i].is_published) return list[i];
    }
    return null;
  }

  function pickVariant(product) {
    var vs = product.variants || [];
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (v.inventory_management !== 'shopify' || v.inventory_policy === 'continue' || v.inventory_quantity > 0) return v;
    }
    return vs[0];
  }

  function buildPayload(bundle) {
    var pv = bundle.physical_variants && bundle.physical_variants[0];
    if (!pv || !pv.id) return null;
    var props = {};
    var ids = [];
    (bundle.products || []).forEach(function (p, i) {
      var v = pickVariant(p);
      if (!v) return;
      ids.push(v.id);
      var vt = v.title && v.title !== 'Default Title' ? ' - ' + String(v.title).replace(/"/g, '') : '';
      props['_#' + (i + 1)] = p.title + vt;
    });
    if (bundle.type === 'physical' && ids.length) props._VariantIds = ids.join(', ');
    return {
      id: pv.id,
      quantity: 1,
      properties: props,
      sections: SECTIONS.map(function (s) { return s.section; }).join(','),
      sections_url: window.location.pathname
    };
  }

  function innerHTML(html, selector) {
    if (!html) return '';
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function render(state) {
    if (state && state.sections) {
      SECTIONS.forEach(function (s) {
        var container = document.getElementById(s.id);
        if (!container) return;
        var target = container.querySelector(s.selector) || container;
        var html = innerHTML(state.sections[s.section], s.selector);
        if (html) target.innerHTML = html;
        if (s.id === 'Cart-Drawer') {
          if (typeof container.notesToggle === 'function') container.notesToggle();
          if (typeof container.removeProductEvent === 'function') container.removeProductEvent();
        }
      });
    }
    if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart:item-added', { product: state });

    var useToast = typeof window.shouldUseCartAddToast === 'function' ? window.shouldUseCartAddToast() : false;
    if (useToast && typeof window.showCartAddToast === 'function' && typeof window.resolveCartAddedLineItem === 'function') {
      var item = window.resolveCartAddedLineItem(state, state && state.variant_id);
      if (item) { window.showCartAddToast(item); return; }
    }
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) {
      document.body.classList.add('open-cc', 'open-cart');
      drawer.classList.add('active');
      if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.rc-card__add, .product-card--add-to-cart-button-simple');
    if (!btn || btn.disabled) return;
    var bundle = findBundle(btn.getAttribute('data-product-handle'));
    if (!bundle) return; // not an MBC bundle – let the theme quick add handle it
    var payload = buildPayload(bundle);
    if (!payload) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.classList.contains('loading')) return;
    btn.classList.add('loading');
    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js?mbcb-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'add failed');
        render(res.j);
      })
      .catch(function () {
        // Fall back to the routine page rather than failing silently.
        var card = btn.closest('.rc-card, product-card, .product-card');
        var link = card && card.querySelector('a[href*="/products/"]');
        if (link) window.location.href = link.href;
      })
      .finally(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-busy');
      });
  }, true);
})();
